import { call, put, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import { REQUEST_MOVIES_BOX_OFFICE, REQUEST_DATES, REQUEST_MOVIES_BOX_OFFICE_HOME, BOX_OFFICE_DISTRIBUTORS, BOX_OFFICE_STUDIOS } from "../actions/types";
import { getMoviesFropAPI, getDatesForBoxOffice, getBoxOfficeHome, getBoxOfficeDistributors, getBoxOfficeStudios } from '../api/boxoffice.api';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";
import moment from 'moment';
import {
    moviesBoxOfficeSuccess,
    moviesBoxOfficeHomeSuccess,
    requestDatesSuccess,
    requestDatesFailed,
    getBoxOfficeDistributorsSucceeded,
    getBoxOfficeStudiosSucceeded
} from '../actions/boxoffice.actions';
import { showSpinner, hideSpinner } from '../actions/loading.actions';

function* getBoxOfficeMoviesSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMoviesFropAPI, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            let movies = response.data;
            yield put(moviesBoxOfficeSuccess(movies));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}


// Get box office data for home component. Different call.
function* getBoxOfficeMoviesHomeSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getBoxOfficeHome, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(moviesBoxOfficeHomeSuccess(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

function* getDates(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getDatesForBoxOffice);
        if (response.status) {
            yield put(hideSpinner());
        }
        let formatedData = [];
        let index = 0;
        if (response.data.length !== 0) {
            response.data.forEach(function (item) {
                let startDate = moment.unix(item.unix_start_date);
                let endDate = moment.unix(item.unix_end_date);
                let formatedDataItem = '';
                if (startDate.month() === endDate.month()) {
                    formatedDataItem = startDate.format('DD') + ' - ' + endDate.format('DD') + ' ' + endDate.format('MMMM').toUpperCase() + ' ' + endDate.format('YYYY');
                } else {
                    formatedDataItem = startDate.format('DD') + ' ' + startDate.format('MMMM').toUpperCase() + ' - ' + endDate.format('DD') + ' ' + endDate.format('MMMM').toUpperCase() + ' ' + endDate.format('YYYY');
                }
                formatedData.push(
                    {
                        id: index,
                        value: formatedDataItem,
                        startDate: startDate.format('YYYYMMDD'),
                        endDate: endDate.format('YYYYMMDD')
                    }
                );
                index++;
            });
            if (response.status === 200) {
                yield put(requestDatesSuccess({ dates: formatedData }));
    
                let payload = {
                    startDate: formatedData[0].startDate,
                    genres: []
                };
    
                yield put({ type: REQUEST_MOVIES_BOX_OFFICE, payload });
                yield put({ type: BOX_OFFICE_DISTRIBUTORS, payload });
                yield put({ type: BOX_OFFICE_STUDIOS, payload });
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));

    }
}

function* getBoxOfficeDistributorsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getBoxOfficeDistributors, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getBoxOfficeDistributorsSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

function* getBoxOfficeStudiosSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getBoxOfficeStudios, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getBoxOfficeStudiosSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000)
        yield put(hideGeneralError(''));
    }
}

export default function* boxofficeSaga() {
    yield takeLatest(REQUEST_MOVIES_BOX_OFFICE, getBoxOfficeMoviesSaga);
    yield takeLatest(REQUEST_MOVIES_BOX_OFFICE_HOME, getBoxOfficeMoviesHomeSaga);
    yield takeLatest(REQUEST_DATES, getDates);
    yield takeLatest(BOX_OFFICE_DISTRIBUTORS, getBoxOfficeDistributorsSaga);
    yield takeLatest(BOX_OFFICE_STUDIOS, getBoxOfficeStudiosSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/boxoffice.saga.js